import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCore from './locales/en/translation.json';
import enExtra from './locales/en/pagesExtra.json';
import zhCore from './locales/zh/translation.json';
import zhExtra from './locales/zh/pagesExtra.json';

const en = { ...enCore, ...enExtra };
const zh = { ...zhCore, ...zhExtra };

const resources = {
  en: { translation: en },
  zh: { translation: zh },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'operis_language',
    },
    react: { useSuspense: false },
  });

export default i18n;

